//
// using the store for this makes things more complicated,
// however it will allow GLOBAL uploads in the future & parallel uploads
// in the future
//

import SubmissionError from '../../../error/SubmissionError'
import fetch from '../../../utils/fetch'
import FILE_ACTION_TYPES, {FILE_STATUS} from "../../constants/actionTypes";


const initialState = {
    filesQueue: [],
    fileUploading: null,
    filesComplete: [],
    filesError: [],
}

const uploadTemplate = {
    status: null, // QUEUE, UPLOADING, ERROR, SUCCESS
    progress: 0, // 0-100
    //autoUpload: false, // upload immediately when added
    action_type: FILE_ACTION_TYPES.observation_record.name, // upload type

    path: null, // either local or server URL, used as the unique identifier regardless of status
    marker: null, // grouped together by marker
    observation: null, // grouped together by observation
    blob: null, // will be converted to appropriate file for upload

    name: null, // file name from client or server

    '@id': null, // server side IRI
    id: null, // server side UUID
    size: null, // file size from server
    mime_type: null, // file mime type from server
    created_at: null, // server side created at
    updated_at: null, // server side updated at

    error: null, // error message
}

export const types = {
    ADD_FILE: "ADD_FILE",
    ADD_FILES: "ADD_FILES",
    START_UPLOAD: "START_UPLOAD",
    FINISH_UPLOAD: "FINISH_UPLOAD",
    ERROR_UPLOAD: "ERROR_UPLOAD",
    REMOVE_UPLOAD: "REMOVE_UPLOAD",
    CLEAR_UPLOADS: "CLEAR_UPLOADS"
}

const getters = {
    countQueue(state){
        return state.filesQueue.length
    },
    countComplete(state){
        return state.filesComplete.length
    },
    countError(state){
        return state.filesError.length
    },
    count(state){
        return state.filesQueue.length + state.filesComplete.length + state.filesError.length
    },
    uploads(state){
        if(state.fileUploading){
            return [...state.filesComplete, state.fileUploading, ...state.filesQueue]
        }
        return [...state.filesComplete, ...state.filesQueue]
    },
    isUploading(state){
        if(state.fileUploading){
            return true
        }
        if(state.filesQueue.length !== 0){
            return true
        }
    }
}

const mutations = {
    [types.ADD_FILES](state, files) {
        files.forEach((file) => {
            state.filesQueue.push({
                ...uploadTemplate,
                ...file,
                status: FILE_STATUS.QUEUE,
            })
        })
    },
    [types.ADD_FILE](state, file) {
        state.filesQueue.push({
            ...uploadTemplate,
            ...file,
            status: FILE_STATUS.QUEUE,
        })
    },
    [types.START_UPLOAD](state, file) {
        state.fileUploading = {
            ...uploadTemplate,
            ...file,
            status: FILE_STATUS.UPLOADING,
        }
    },
    [types.FINISH_UPLOAD](state, payload) {
        const uploadNew = {
            ...uploadTemplate,
            ...payload,
            status: FILE_STATUS.SUCCESS,
            progress: 100,
        }
        state.fileUploading = null
        state.filesComplete.push(uploadNew)
    },
    [types.ERROR_UPLOAD](state, payload) {
        const uploadError = {
            status: FILE_STATUS.ERROR,
            progress: 100,
            error: payload.error instanceof SubmissionError
                ? payload.errors._error
                : payload.error.message
        }
        state.filesComplete.push(uploadError)
    },
    [types.REMOVE_UPLOAD](state, file) {
        state.filesQueue = state.filesQueue.filter((f) => f.path !== file.path)
        state.filesComplete = state.filesComplete.filter((f) => f.path !== file.path)
    },
    [types.CLEAR_UPLOADS](state) {
        console.log('CLEAR_UPLOADS')
        const currentState = state
        state.filesQueue = [],
        state.fileUploading = null,
        state.filesComplete = [],
        state.filesError = [],

        currentState.filesQueue.forEach((file) => {
            URL.revokeObjectURL(file.path) // frees up browser memory for image
        })
        currentState.filesError.forEach((file) => {
            URL.revokeObjectURL(file.path) // frees up browser memory for image
        })
    }
}

const actions = {
    // will take an array of objects or a single upload
    uploadFiles({commit, dispatch, state}, data){
        console.log('uploadFiles')
        let files = data.files
        if(!Array.isArray(files)){
            files = [files]
        }
        files = files.map((file)=>{return {
            ...uploadTemplate,
            ...file,
            stats: FILE_STATUS.QUEUE,
            path: URL.createObjectURL(file.blob),
            projectId: data.projectId
        }})
        if(state.fileUploading === null){
            let firstUpload = files.shift()
            dispatch('uploadFile', firstUpload)
        }
        commit(types.ADD_FILES, files)
    },
    async uploadFile({ commit, dispatch, state }, file) {
        commit(types.START_UPLOAD, file)

        // build form data
        const formData = new FormData()
        formData.append('file', file.blob, file.name)
        formData.append('actionType', file.action_type)
        formData.append('projectId', file.projectId)

        const fetchPromise = fetch('/file_objects', {
            method: 'POST',
            body: formData
        }).then((response) => {
            return response.json()
        }).then((data) => {
            commit(types.FINISH_UPLOAD, {...file, ...data })
        }).catch((error) => {
            commit(types.ERROR_UPLOAD, {...file, error: error })
        }).finally(() => {
            URL.revokeObjectURL(file.path) // frees up browser memory for image after uploaded
            if(state.filesQueue.length > 0 ){
                let nextUpload = state.filesQueue.shift()
                dispatch('uploadFile', nextUpload)
            }
        })
    },
    removeUpload({ commit, dispatch }, file) {
        if(!file['@id']){
            // file does not exist on server
            commit(types.REMOVE_UPLOAD, file)
            URL.revokeObjectURL(file.path) // frees up browser memory for image
            return;
        }
        dispatch('removeUploadFromServer', file)
    },
    async removeUploadFromServer({ commit }, file) {
        const fetchPromise = fetch(file['@id'], {
            method: 'DELETE'
        }).then((response) => {
            commit(types.REMOVE_UPLOAD, file)
        }).catch((error) => {
            commit(types.REMOVE_UPLOAD, file)
            commit(types.ERROR_UPLOAD, {...file, error: error })
        })
    },
    clearUploads: ({ commit }) => {
        commit(types.CLEAR_UPLOADS)
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters: getters,
    actions: actions,
    mutations: mutations,
}
